import { useEffect } from "react";

interface ToastProps {
  message: string;
  onClose: () => void;
}

export default function Toast({ message, onClose }: ToastProps) {
  useEffect(() => {
    const timer = window.setTimeout(onClose, 2400);
    return () => window.clearTimeout(timer);
  }, [message, onClose]);

  return (
    <div className="fixed inset-x-0 bottom-8 z-[80] flex justify-center px-4 animate-fade-up">
      <div className="flex items-center gap-2 rounded-full bg-foreground-950/92 px-5 py-3 text-sm text-background-50">
        <span className="flex h-5 w-5 items-center justify-center">
          <i className="ri-information-line text-base" />
        </span>
        <span>{message}</span>
      </div>
    </div>
  );
}